// src/services/push/WebPushProvider.js
//
// Browser-side mirror of the backend's provider contract. The CRM shell only
// ever talks to `pushService`; it never imports Firebase directly. Swapping the
// browser push provider is therefore one new file plus one registry line, the
// same as on the server.

export default class WebPushProvider {
  /** Stable name; must match the backend provider name where they pair up. */
  static providerName = 'base';

  get name() { return this.constructor.providerName; }

  /** True when the provider has the configuration it needs. */
  isConfigured() { return false; }

  /** True when this browser can actually receive push at all. */
  isSupported() { return false; }

  /**
   * Ask for permission and obtain a delivery token.
   * @returns {Promise<string|null>} token, or null if unavailable/denied
   */
  async requestToken() { return null; }

  /** Stop receiving on this browser. */
  async deleteToken() { return false; }

  /**
   * Foreground message handler.
   * @param {(payload: {title?:string, body?:string, data?:Object}) => void} cb
   * @returns {Function} unsubscribe
   */
  onMessage() { return () => {}; }
}
